export const TIMING_MODE = {
  fromStartOfDay: 'from_start_of_day',
  elapsedTime: 'elapsed_time',
}

export const TIMING_MODE_OPTIONS = [
  { key: TIMING_MODE.fromStartOfDay, text: 'From start of day' },
  { key: TIMING_MODE.elapsedTime, text: 'After elapsed time' },
]
